import React from 'react'
// import { OUR_TEAM } from '../data/data';
import TeamCard from '../component/our-team/TeamCard';
import team1 from "../assets/images/sattva_team/sreenath.png"
import team2 from "../assets/images/sattva_team/sridhar.png"
import team3 from "../assets/images/sattva_team/sajan.png"
import team4 from "../assets/images/sattva_team/haroon.png"
import team5 from "../assets/images/sattva_team/aani.png"
import team6 from "../assets/images/sattva_team/thazni.png"

const OurTeamComponent = () => {
    window.scrollTo(0, 0);
    const DummyUser = 'https://imgs.search.brave.com/HHv4G66L_oIc59sq5PJHB191jYrN0Wh0OR9z0neEfec/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMjIw/ODQ3NTE5Ni92ZWN0/b3IvdXNlci1pY29u/LXJlcHJlc2VudGlu/Zy1wcm9maWxlLWFj/Y291bnQuanBnP3M9/NjEyeDYxMiZ3PTAm/az0yMCZjPUpFOS1t/UEZiamRPMWR1aEZO/SE1TakZnZWtvQVdD/Q05WRnRCQW1LSDdS/TTg9'

    const OUR_TEAM = {
        leadership: [
            {
                id: 1,
                role: "Board of Director",
                name: "Sreenath K P",
                designation: "Board of Directors",
                image: team1,
                linkedin: "https://www.linkedin.com/in/sreenath-kp-82b74a35"
            },
            {
                id: 2,
                role: "Board of Director",
                name: "Sridhar Rajagopal",
                designation: "Board of Directors",
                image: team2,
                linkedin: "http://linkedin.com/in/sridhar-rajagopal-00436115"
            },
        ],

        advocacy: [
            {
                id: 1,
                role: "Advocacy",
                name: "Rajesh Kumar",
                designation: "Advocacy",
                image: DummyUser,
                linkedin: "https://linkedin.com/in/"
            },
            {
                id: 2,
                role: "Advocacy",
                name: "Rajendran Pillai",
                designation: "Advocacy",
                image: DummyUser,
                linkedin: "https://linkedin.com/in/"
            },
            {
                id: 3,
                role: "Advocacy",
                name: "Suresh Patil",
                designation: "Advocacy",
                image: DummyUser,
                linkedin: "https://linkedin.com/in/"
            },
            {
                id: 4,
                role: "Advocacy",
                name: "Neha Verma",
                designation: "Advocacy",
                image: DummyUser,
                linkedin: "https://linkedin.com/in/"
            }
        ],

        teamMembers: [
            {
                id: 5,
                name: "Sajan SB",
                role: "CTO",
                image: team3,
                linkedin: "http://linkedin.com/in/sajan-sathikumar"
            },
            {
                id: 6,
                name: "Haroon Haridas",
                role: "Senior ESG Associate",
                image: team4,
                linkedin: "https://www.linkedin.com/in/haroonharidas"
            },
            {
                id: 7,
                name: "Aani P",
                role: "Program Manager",
                image: team5,
                linkedin: "http://linkedin.com/in/aani-p-703502200"
            },
            {
                id: 8,
                name: "Thazni Thameen",
                role: "ESG Associate - Growth and Partnership",
                image: team6,
                linkedin: "http://linkedin.com/in/thazni-thameen"
            },
        ]
    }

    return (
        <article className={`flex flex-col items-center p-4 py-36 bg-gray-50 dark:bg-[#0F172A]
        bg-gradient-to-b from-green-600/20 dark:from-green-600/40 via-green-600/10 dark:via-green-600/20 to-transparent`}>
            <div className="container">
                {/* MAIN PILLARS */}
                <div className="text-left md:text-center">
                    <h4 className="lg:text-5xl text-4xl lg:leading-normal leading-normal font-medium mb-4 position-relative dark:text-white">Our Team</h4>
                    <h6 className="text-blue-600 text-base font-medium uppercase mt-10 mb-4">Our Leadership</h6>
                </div>
                <section className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[2%] w-full'>
                    {OUR_TEAM?.leadership?.map(member => (
                        <TeamCard key={member.id} {...member} />
                    ))}
                </section>
                {/* <div className="text-left md:text-center">
                    <h6 className="text-blue-600 text-base font-medium uppercase mt-10 mb-4">Our Advocacy</h6>
                </div>
                <section className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[2%] w-full'>
                    {OUR_TEAM?.advocacy?.map(member => (
                        <TeamCard key={member.id} {...member} />
                    ))}
                </section> */}
                {/* TEAM MEMBERS */}
                <div className="text-left md:text-center">
                    <h6 className="text-blue-600 text-base font-medium uppercase mt-10 mb-4">Our Team</h6>
                </div>
                <section className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[2%] w-full'>
                    {OUR_TEAM?.teamMembers?.map(member => (
                        <TeamCard key={member.id} {...member} />
                    ))}
                </section>
            </div>

        </article>
    )
}

export default OurTeamComponent;